import { getApiBaseUrl } from '../../config/runtimeConfig';

function ensureTrailingSlash(value = '') {
  return value.endsWith('/') ? value : `${value}/`;
}

function normalizeServiceRoot(serviceRoot) {
  if (!serviceRoot) return null;
  const normalized = ensureTrailingSlash(String(serviceRoot).trim());

  // DNN MapHttpRoute already includes the module folder in `/DesktopModules/<Module>/API/`.
  // If host payload mistakenly provides `/API/<Module>/`, strip that extra segment.
  return normalized.replace(/\/API\/[^/]+\/$/i, '/API/');
}

function isDnnServiceRootEnabled(runtimeConfig) {
  return Boolean(runtimeConfig?.serviceRoot);
}

export function createBackendContract(runtimeConfig = {}) {
  if (isDnnServiceRootEnabled(runtimeConfig)) {
    const baseUrl = normalizeServiceRoot(runtimeConfig.serviceRoot);

    return {
      mode: 'dnn',
      baseUrl,
      session: {
        status: 'Session/Status',
        me: 'Session/Me',
        join: 'Session/Join',
        events: null
      },
      game: {
        answer: 'Game/Answer',
        unlock: 'Game/Unlock',
        start: 'Game/Start',
        pause: 'Game/Pause',
        reset: 'Game/Reset',
        stop: 'Game/Stop'
      },
      adminAuth: {
        login: 'AdminAuth/Login',
        logout: 'AdminAuth/Logout',
        me: 'AdminAuth/Me'
      },
      admin: {
        bootstrap: 'Admin/Bootstrap',
        gameStatus: 'Admin/GameStatus',
        gameLog: 'Admin/GameLog',
        draftQuiz: 'Admin/DraftQuiz',
        questionSets: 'Admin/QuestionSets',
        questionSetCreate: 'Admin/QuestionSetsCreate',
        questionSetUpdate: 'Admin/QuestionSetsUpdate',
        questionSetDelete: 'Admin/QuestionSetsDelete',
        questionCreate: 'Admin/QuestionsCreate',
        questionUpdate: 'Admin/QuestionsUpdate',
        questionDelete: 'Admin/QuestionsDelete',
        quizzes: 'Admin/Quizzes',
        quizCreate: 'Admin/QuizzesCreate',
        quizUpdate: 'Admin/QuizzesUpdate',
        quizLoad: 'Admin/QuizzesLoad',
        quizDelete: 'Admin/QuizzesDelete',
        globalSettings: 'Admin/GlobalSettings',
        globalSettingsAssetUpload: 'Admin/GlobalSettingsAssetUpload',
        globalSettingsAssetDelete: 'Admin/GlobalSettingsAssetDelete'
      }
    };
  }

  return {
    mode: 'legacy',
    baseUrl: getApiBaseUrl(),
    session: {
      status: '/session/status',
      me: '/session/me',
      join: '/session/join',
      events: '/session/events'
    },
    game: {
      answer: '/game/answer',
      unlock: '/game/unlock',
      start: '/game/start',
      pause: '/game/pause',
      reset: '/game/reset',
      stop: '/game/stop'
    },
    adminAuth: {
      login: '/admin/login',
      logout: '/admin/logout',
      me: '/admin/me'
    },
    admin: {
      bootstrap: '/admin/bootstrap',
      gameStatus: '/admin/game-status',
      gameLog: '/admin/game-log',
      draftQuiz: '/admin/draft-quiz',
      questionSets: '/admin/question-sets',
      questionSetCreate: '/admin/question-sets',
      questionSetUpdate: '/admin/question-sets',
      questionSetDelete: '/admin/question-sets',
      questionCreate: '/admin/question-sets',
      questionUpdate: '/admin/question-sets',
      questionDelete: '/admin/question-sets',
      quizzes: '/admin/quizzes',
      quizCreate: '/admin/quizzes',
      quizUpdate: '/admin/quizzes',
      quizLoad: '/admin/quizzes',
      quizDelete: '/admin/quizzes',
      globalSettings: '/admin/global-settings',
      globalSettingsAssetUpload: '/admin/global-settings/assets',
      globalSettingsAssetDelete: '/admin/global-settings/assets'
    }
  };
}

export function isAdminPath(path = '', backendContract = null) {
  if (!backendContract) return false;
  if (backendContract.mode === 'dnn') {
    return path.startsWith('AdminAuth/') || path.startsWith('Admin/');
  }
  return path.startsWith('/admin');
}

export function buildEventsUrl(backendContract) {
  if (!backendContract?.session?.events) return null;
  return `${backendContract.baseUrl}${backendContract.session.events}`;
}
